import { createSelector } from 'reselect';

// Array of font sizes and corresponding container widths
const fontSizes = [
    { width: 500, size: 'large' },
    { width: 400, size: 'medium' },
    { width: 300, size: 'small' },
    { width: 0, size: 'xsmall' },
];

// Selector to resize the recorder container and determine the font size based on container width
export const resizeRecorder = createSelector(
    [(state) => state?.containerRef, (state) => state.maxHeight],
    (containerRef, maxHeight) => {
        // Calculate the width of the recorder container's parent element
        const parentWidth = containerRef.current.parentElement.offsetParent.offsetWidth;
        // Calculate the height and width of the recorder container
        const height = Math.min((parentWidth * 3) / 4, maxHeight);
        const width = (height * 4) / 3;
        // Check that the parent width can be measured
        if (parentWidth > 0) {
            // Set height and width of recorder container
            containerRef.current.style.width = width + 'px';
            containerRef.current.style.height = height + 'px';
            // Set recorder font size based on width of the container
            let foundFontSize = null;
            fontSizes.forEach((fontSizeObj) => {
                if (width > fontSizeObj.width && !foundFontSize) {
                    foundFontSize = fontSizeObj.size;
                }
            });
            // Return the found font size
            return foundFontSize;
        }
    },
);
